[
  {
    "code": "01",
    "nom": "Ain",
    "slug": "ain",
    "zoom": 9.3,
    "localisation": {
      "longitude": 5.348666025399395,
      "latitude": 46.099798450280282
    }
  },
  {
    "code": "02",
    "nom": "Aisne",
    "slug": "aisne",
    "zoom": 9.3,
    "localisation": {
      "longitude": 3.559228138131865,
      "latitude": 49.561047640550804
    }
  },
  {
    "code": "03",
    "nom": "Allier",
    "slug": "allier",
    "zoom": 9.3,
    "localisation": {
      "longitude": 3.187565399965392,
      "latitude": 46.393663504602458
    }
  },
  {
    "code": "04",
    "nom": "Alpes-de-Haute-Provence",
    "slug": "alpes-de-haute-provence",
    "zoom": 9.3,
    "localisation": {
      "longitude": 6.244559228032303,
      "latitude": 44.106225299144775
    }
  },
  {
    "code": "05",
    "nom": "Hautes-Alpes",
    "slug": "hautes-alpes",
    "zoom": 9.3,
    "localisation": {
      "longitude": 6.264858477005842,
      "latitude": 44.663773434093478
    }
  },
  {
    "code": "06",
    "nom": "Alpes-Maritimes",
    "slug": "alpes-maritimes",
    "zoom": 9.3,
    "localisation": {
      "longitude": 7.11620883820964,
      "latitude": 43.938236643815486
    }
  },
  {
    "code": "07",
    "nom": "Ardèche",
    "slug": "ardeche",
    "zoom": 9.3,
    "localisation": {
      "longitude": 4.425531629330188,
      "latitude": 44.752642988235216
    }
  },
  {
    "code": "08",
    "nom": "Ardennes",
    "slug": "ardennes",
    "zoom": 9.3,
    "localisation": {
      "longitude": 4.64062940465854,
      "latitude": 49.616057077754739
    }
  },
  {
    "code": "09",
    "nom": "Ariège",
    "slug": "ariege",
    "zoom": 9.5,
    "localisation": {
      "longitude": 1.503639287555638,
      "latitude": 42.920893264531422
    }
  },
  {
    "code": "10",
    "nom": "Aube",
    "slug": "aube",
    "zoom": 9.3,
    "localisation": {
      "longitude": 4.161601781275763,
      "latitude": 48.304602869892747
    }
  },
  {
    "code": "11",
    "nom": "Aude",
    "slug": "aude",
    "zoom": 9.3,
    "localisation": {
      "longitude": 2.413675525924558,
      "latitude": 43.103265825583428
    }
  },
  {
    "code": "12",
    "nom": "Aveyron",
    "slug": "aveyron",
    "zoom": 9.3,
    "localisation": {
      "longitude": 2.678475218844927,
      "latitude": 44.281160005638597
    }
  },
  {
    "code": "13",
    "nom": "Bouches-du-Rhône",
    "slug": "bouches-du-rhone",
    "zoom": 9.3,
    "localisation": {
      "longitude": 5.085361269441959,
      "latitude": 43.545813018177682
    }
  },
  {
    "code": "14",
    "nom": "Calvados",
    "slug": "calvados",
    "zoom": 9.3,
    "localisation": {
      "longitude": -0.361598715951831,
      "latitude": 49.099624864919718
    }
  },
  {
    "code": "15",
    "nom": "Cantal",
    "slug": "cantal",
    "zoom": 9.3,
    "localisation": {
      "longitude": 2.668915768733588,
      "latitude": 45.05130587390169
    }
  },
  {
    "code": "16",
    "nom": "Charente",
    "slug": "charente",
    "zoom": 9.3,
    "localisation": {
      "longitude": 0.203242053316784,
      "latitude": 45.718687935826821
    }
  },
  {
    "code": "17",
    "nom": "Charente-Maritime",
    "slug": "charente-maritime",
    "zoom": 9.3,
    "localisation": {
      "longitude": -0.678828180011893,
      "latitude": 45.775078115409869
    }
  },
  {
    "code": "18",
    "nom": "Cher",
    "slug": "cher",
    "zoom": 9.3,
    "localisation": {
      "longitude": 2.491138526672551,
      "latitude": 47.065856066370308
    }
  },
  {
    "code": "19",
    "nom": "Corrèze",
    "slug": "correze",
    "zoom": 9.3,
    "localisation": {
      "longitude": 1.877391973643968,
      "latitude": 45.357334333349371
    }
  },
  {
    "code": "21",
    "nom": "Côte-d'Or",
    "slug": "cote-d-or",
    "zoom": 9.3,
    "localisation": {
      "longitude": 4.771734059306371,
      "latitude": 47.425504861404967
    }
  },
  {
    "code": "22",
    "nom": "Côtes-d'Armor",
    "slug": "cotes-d-armor",
    "zoom": 9.3,
    "localisation": {
      "longitude": -2.864464345576853,
      "latitude": 48.439991322292975
    }
  },
  {
    "code": "23",
    "nom": "Creuse",
    "slug": "creuse",
    "zoom": 9.3,
    "localisation": {
      "longitude": 2.018307483430017,
      "latitude": 46.09063234352147
    }
  },
  {
    "code": "24",
    "nom": "Dordogne",
    "slug": "dordogne",
    "zoom": 9.3,
    "localisation": {
      "longitude": 0.741040317517638,
      "latitude": 45.104821514979115
    }
  },
  {
    "code": "25",
    "nom": "Doubs",
    "slug": "doubs",
    "zoom": 9.3,
    "localisation": {
      "longitude": 6.362870425989155,
      "latitude": 47.16609513619715
    }
  },
  {
    "code": "26",
    "nom": "Drôme",
    "slug": "drome",
    "zoom": 9.3,
    "localisation": {
      "longitude": 5.167325033858678,
      "latitude": 44.685347548910876
    }
  },
  {
    "code": "27",
    "nom": "Eure",
    "slug": "eure",
    "zoom": 9.3,
    "localisation": {
      "longitude": 0.996354215855167,
      "latitude": 49.11382227521672
    }
  },
  {
    "code": "28",
    "nom": "Eure-et-Loir",
    "slug": "eure-et-loir",
    "zoom": 9.3,
    "localisation": {
      "longitude": 1.370033152305838,
      "latitude": 48.388033877010386
    }
  },
  {
    "code": "29",
    "nom": "Finistère",
    "slug": "finistere",
    "zoom": 9.3,
    "localisation": {
      "longitude": -4.059095901665024,
      "latitude": 48.261386770195145
    }
  },
  {
    "code": "2A",
    "nom": "Corse-du-Sud",
    "slug": "corse-du-sud",
    "zoom": 9.3,
    "localisation": {
      "longitude": 8.988234351564222,
      "latitude": 41.86398928172553
    }
  },
  {
    "code": "2B",
    "nom": "Haute-Corse",
    "slug": "haute-corse",
    "zoom": 9.3,
    "localisation": {
      "longitude": 9.206436950725896,
      "latitude": 42.394659045485668
    }
  },
  {
    "code": "30",
    "nom": "Gard",
    "slug": "gard",
    "zoom": 9.3,
    "localisation": {
      "longitude": 4.179823679654268,
      "latitude": 43.993762729920775
    }
  },
  {
    "code": "31",
    "nom": "Haute-Garonne",
    "slug": "haute-garonne",
    "zoom": 9.3,
    "localisation": {
      "longitude": 1.175062784816758,
      "latitude": 43.358821316445614
    }
  },
  {
    "code": "32",
    "nom": "Gers",
    "slug": "gers",
    "zoom": 9.3,
    "localisation": {
      "longitude": 0.452998281716819,
      "latitude": 43.692948200276071
    }
  },
  {
    "code": "33",
    "nom": "Gironde",
    "slug": "gironde",
    "zoom": 9.3,
    "localisation": {
      "longitude": -0.582543178713593,
      "latitude": 44.838973491313318
    }
  },
  {
    "code": "34",
    "nom": "Hérault",
    "slug": "herault",
    "zoom": 9.3,
    "localisation": {
      "longitude": 3.368286888613917,
      "latitude": 43.579513462611636
    }
  },
  {
    "code": "35",
    "nom": "Ille-et-Vilaine",
    "slug": "ille-et-vilaine",
    "zoom": 9.3,
    "localisation": {
      "longitude": -1.638013595292116,
      "latitude": 48.15481762958985
    }
  },
  {
    "code": "36",
    "nom": "Indre",
    "slug": "indre",
    "zoom": 9.3,
    "localisation": {
      "longitude": 1.576027176470445,
      "latitude": 46.778336219085674
    }
  },
  {
    "code": "37",
    "nom": "Indre-et-Loire",
    "slug": "indre-et-loire",
    "zoom": 9.3,
    "localisation": {
      "longitude": 0.691158926417557,
      "latitude": 47.258521918199868
    }
  },
  {
    "code": "38",
    "nom": "Isère",
    "slug": "isere",
    "zoom": 9.3,
    "localisation": {
      "longitude": 5.574236336789287,
      "latitude": 45.26395628867062
    }
  },
  {
    "code": "39",
    "nom": "Jura",
    "slug": "jura",
    "zoom": 9.3,
    "localisation": {
      "longitude": 5.697495901417199,
      "latitude": 46.729342559560436
    }
  },
  {
    "code": "40",
    "nom": "Landes",
    "slug": "landes",
    "zoom": 9.3,
    "localisation": {
      "longitude": -0.783832347129465,
      "latitude": 43.965857084545583
    }
  },
  {
    "code": "41",
    "nom": "Loir-et-Cher",
    "slug": "loir-et-cher",
    "zoom": 9.3,
    "localisation": {
      "longitude": 1.427957892004081,
      "latitude": 47.616946597818789
    }
  },
  {
    "code": "42",
    "nom": "Loire",
    "slug": "loire",
    "zoom": 9.3,
    "localisation": {
      "longitude": 4.164661841030067,
      "latitude": 45.727982046609476
    }
  },
  {
    "code": "43",
    "nom": "Haute-Loire",
    "slug": "haute-loire",
    "zoom": 9.3,
    "localisation": {
      "longitude": 3.806461355062912,
      "latitude": 45.1281134930463
    }
  },
  {
    "code": "44",
    "nom": "Loire-Atlantique",
    "slug": "loire-atlantique",
    "zoom": 9.3,
    "localisation": {
      "longitude": -1.678857159055145,
      "latitude": 47.362998795358386
    }
  },
  {
    "code": "45",
    "nom": "Loiret",
    "slug": "loiret",
    "zoom": 9.3,
    "localisation": {
      "longitude": 2.344134676881679,
      "latitude": 47.911880260805567
    }
  },
  {
    "code": "46",
    "nom": "Lot",
    "slug": "lot",
    "zoom": 9.3,
    "localisation": {
      "longitude": 1.605480739992476,
      "latitude": 44.624597695242649
    }
  },
  {
    "code": "47",
    "nom": "Lot-et-Garonne",
    "slug": "lot-et-garonne",
    "zoom": 9.5,
    "localisation": {
      "longitude": 0.460858224921808,
      "latitude": 44.367995171221999
    }
  },
  {
    "code": "48",
    "nom": "Lozère",
    "slug": "lozere",
    "zoom": 9.3,
    "localisation": {
      "longitude": 3.499605769166552,
      "latitude": 44.517589096965125
    }
  },
  {
    "code": "49",
    "nom": "Maine-et-Loire",
    "slug": "maine-et-loire",
    "zoom": 9.3,
    "localisation": {
      "longitude": -0.559433251626706,
      "latitude": 47.389915457052041
    }
  },
  {
    "code": "50",
    "nom": "Manche",
    "slug": "manche",
    "zoom": 9.1,
    "localisation": {
      "longitude": -1.328844995724477,
      "latitude": 49.081142979030844
    }
  },
  {
    "code": "51",
    "nom": "Marne",
    "slug": "marne",
    "zoom": 9.3,
    "localisation": {
      "longitude": 4.238327480325601,
      "latitude": 48.949892341664636
    }
  },
  {
    "code": "52",
    "nom": "Haute-Marne",
    "slug": "haute-marne",
    "zoom": 9.3,
    "localisation": {
      "longitude": 5.225602822550032,
      "latitude": 48.110388495250781
    }
  },
  {
    "code": "53",
    "nom": "Mayenne",
    "slug": "mayenne",
    "zoom": 9.3,
    "localisation": {
      "longitude": -0.657456096802534,
      "latitude": 48.147227576298334
    }
  },
  {
    "code": "54",
    "nom": "Meurthe-et-Moselle",
    "slug": "meurthe-et-moselle",
    "zoom": 9.3,
    "localisation": {
      "longitude": 6.161667632250049,
      "latitude": 48.789087980172184
    }
  },
  {
    "code": "55",
    "nom": "Meuse",
    "slug": "meuse",
    "zoom": 9.3,
    "localisation": {
      "longitude": 5.381434531505527,
      "latitude": 48.991021078899053
    }
  },
  {
    "code": "56",
    "nom": "Morbihan",
    "slug": "morbihan",
    "zoom": 9.3,
    "localisation": {
      "longitude": -2.811052115380253,
      "latitude": 47.846704658327681
    }
  },
  {
    "code": "57",
    "nom": "Moselle",
    "slug": "moselle",
    "zoom": 9.3,
    "localisation": {
      "longitude": 6.661624220306487,
      "latitude": 49.037366986159327
    }
  },
  {
    "code": "58",
    "nom": "Nièvre",
    "slug": "nievre",
    "zoom": 9.3,
    "localisation": {
      "longitude": 3.504223955098858,
      "latitude": 47.115778469521914
    }
  },
  {
    "code": "59",
    "nom": "Nord",
    "slug": "nord",
    "zoom": 9.3,
    "localisation": {
      "longitude": 3.214201790735322,
      "latitude": 50.448154659235627
    }
  },
  {
    "code": "60",
    "nom": "Oise",
    "slug": "oise",
    "zoom": 9.3,
    "localisation": {
      "longitude": 2.424915986599554,
      "latitude": 49.409987385575796
    }
  },
  {
    "code": "61",
    "nom": "Orne",
    "slug": "orne",
    "zoom": 9.3,
    "localisation": {
      "longitude": 0.127763902018232,
      "latitude": 48.623008345761932
    }
  },
  {
    "code": "62",
    "nom": "Pas-de-Calais",
    "slug": "pas-de-calais",
    "zoom": 9.3,
    "localisation": {
      "longitude": 2.28619300931138,
      "latitude": 50.493911696247558
    }
  },
  {
    "code": "63",
    "nom": "Puy-de-Dôme",
    "slug": "puy-de-dome",
    "zoom": 9.3,
    "localisation": {
      "longitude": 3.140071103255325,
      "latitude": 45.72593841410395
    }
  },
  {
    "code": "64",
    "nom": "Pyrénées-Atlantiques",
    "slug": "pyrenees-atlantiques",
    "zoom": 9.3,
    "localisation": {
      "longitude": -0.760948286617372,
      "latitude": 43.256265325918591
    }
  },
  {
    "code": "65",
    "nom": "Hautes-Pyrénées",
    "slug": "hautes-pyrenees",
    "zoom": 9.3,
    "localisation": {
      "longitude": 0.163914749725104,
      "latitude": 43.053668363159161
    }
  },
  {
    "code": "66",
    "nom": "Pyrénées-Orientales",
    "slug": "pyrenees-orientales",
    "zoom": 9.3,
    "localisation": {
      "longitude": 2.522179940125737,
      "latitude": 42.599749769315281
    }
  },
  {
    "code": "67",
    "nom": "Bas-Rhin",
    "slug": "bas-rhin",
    "zoom": 9.3,
    "localisation": {
      "longitude": 7.552055542392739,
      "latitude": 48.671309691931114
    }
  },
  {
    "code": "68",
    "nom": "Haut-Rhin",
    "slug": "haut-rhin",
    "zoom": 9.3,
    "localisation": {
      "longitude": 7.273894031759741,
      "latitude": 47.859356136322752
    }
  },
  {
    "code": "69",
    "nom": "Rhône",
    "slug": "rhone",
    "zoom": 9.3,
    "localisation": {
      "longitude": 4.640949259558913,
      "latitude": 45.871047330627775
    }
  },
  {
    "code": "70",
    "nom": "Haute-Saône",
    "slug": "haute-saone",
    "zoom": 9.3,
    "localisation": {
      "longitude": 6.087280301174322,
      "latitude": 47.641294060104357
    }
  },
  {
    "code": "71",
    "nom": "Saône-et-Loire",
    "slug": "saone-et-loire",
    "zoom": 9.3,
    "localisation": {
      "longitude": 4.542948650171613,
      "latitude": 46.644818848710443
    }
  },
  {
    "code": "72",
    "nom": "Sarthe",
    "slug": "sarthe",
    "zoom": 9.3,
    "localisation": {
      "longitude": 0.222581023795952,
      "latitude": 47.994975280982842
    }
  },
  {
    "code": "73",
    "nom": "Savoie",
    "slug": "savoie",
    "zoom": 9.3,
    "localisation": {
      "longitude": 6.442849016866783,
      "latitude": 45.477583743140563
    }
  },
  {
    "code": "74",
    "nom": "Haute-Savoie",
    "slug": "haute-savoie",
    "zoom": 9.3,
    "localisation": {
      "longitude": 6.428318038499181,
      "latitude": 46.034630274945165
    }
  },
  {
    "code": "75",
    "nom": "Paris",
    "slug": "paris",
    "zoom": 12,
    "localisation": {
      "longitude": 2.34208259060678,
      "latitude": 48.856648617634399
    }
  },
  {
    "code": "76",
    "nom": "Seine-Maritime",
    "slug": "seine-maritime",
    "zoom": 9.3,
    "localisation": {
      "longitude": 1.027901435386773,
      "latitude": 49.65478567738748
    }
  },
  {
    "code": "77",
    "nom": "Seine-et-Marne",
    "slug": "seine-et-marne",
    "zoom": 9.3,
    "localisation": {
      "longitude": 2.934024012697684,
      "latitude": 48.627627035496232
    }
  },
  {
    "code": "78",
    "nom": "Yvelines",
    "slug": "yvelines",
    "zoom": 10,
    "localisation": {
      "longitude": 1.841257365940418,
      "latitude": 48.815378470875281
    }
  },
  {
    "code": "79",
    "nom": "Deux-Sèvres",
    "slug": "deux-sevres",
    "zoom": 9.3,
    "localisation": {
      "longitude": -0.317848757930099,
      "latitude": 46.557052807843341
    }
  },
  {
    "code": "80",
    "nom": "Somme",
    "slug": "somme",
    "zoom": 9.3,
    "localisation": {
      "longitude": 2.276502457217174,
      "latitude": 49.957904035948616
    }
  },
  {
    "code": "81",
    "nom": "Tarn",
    "slug": "tarn",
    "zoom": 9.3,
    "localisation": {
      "longitude": 2.165745657411694,
      "latitude": 43.785581864754256
    }
  },
  {
    "code": "82",
    "nom": "Tarn-et-Garonne",
    "slug": "tarn-et-garonne",
    "zoom": 9.3,
    "localisation": {
      "longitude": 1.282400266932155,
      "latitude": 44.085633739531417
    }
  },
  {
    "code": "83",
    "nom": "Var",
    "slug": "var",
    "zoom": 9.3,
    "localisation": {
      "longitude": 6.244632767004941,
      "latitude": 43.44210602357137
    }
  },
  {
    "code": "84",
    "nom": "Vaucluse",
    "slug": "vaucluse",
    "zoom": 9.3,
    "localisation": {
      "longitude": 5.177322015176259,
      "latitude": 44.007242722634473
    }
  },
  {
    "code": "85",
    "nom": "Vendée",
    "slug": "vendee",
    "zoom": 9.3,
    "localisation": {
      "longitude": -1.298325800784565,
      "latitude": 46.674956357764763
    }
  },
  {
    "code": "86",
    "nom": "Vienne",
    "slug": "vienne",
    "zoom": 9.3,
    "localisation": {
      "longitude": 0.459451022802407,
      "latitude": 46.564943763503223
    }
  },
  {
    "code": "87",
    "nom": "Haute-Vienne",
    "slug": "haute-vienne",
    "zoom": 9.3,
    "localisation": {
      "longitude": 1.234939771363161,
      "latitude": 45.892426145772646
    }
  },
  {
    "code": "88",
    "nom": "Vosges",
    "slug": "vosges",
    "zoom": 9.3,
    "localisation": {
      "longitude": 6.380323394855568,
      "latitude": 48.196272829601938
    }
  },
  {
    "code": "89",
    "nom": "Yonne",
    "slug": "yonne",
    "zoom": 9.3,
    "localisation": {
      "longitude": 3.56319200926921,
      "latitude": 47.840617093082535
    }
  },
  {
    "code": "90",
    "nom": "Territoire de Belfort",
    "slug": "territoire-de-belfort",
    "zoom": 10.5,
    "localisation": {
      "longitude": 6.92853544042236,
      "latitude": 47.631867536887675
    }
  },
  {
    "code": "91",
    "nom": "Essonne",
    "slug": "essonne",
    "zoom": 10,
    "localisation": {
      "longitude": 2.243146979473284,
      "latitude": 48.522490704308538
    }
  },
  {
    "code": "92",
    "nom": "Hauts-de-Seine",
    "slug": "hauts-de-seine",
    "zoom": 11,
    "localisation": {
      "longitude": 2.245630223738104,
      "latitude": 48.847576430009788
    }
  },
  {
    "code": "93",
    "nom": "Seine-Saint-Denis",
    "slug": "seine-saint-denis",
    "zoom": 11.5,
    "localisation": {
      "longitude": 2.478276673716935,
      "latitude": 48.917833599986004
    }
  },
  {
    "code": "94",
    "nom": "Val-de-Marne",
    "slug": "val-de-marne",
    "zoom": 11.5,
    "localisation": {
      "longitude": 2.46880070325782,
      "latitude": 48.77761519775882
    }
  },
  {
    "code": "95",
    "nom": "Val-d'Oise",
    "slug": "val-d-oise",
    "zoom": 10.5,
    "localisation": {
      "longitude": 2.130764649315437,
      "latitude": 49.0827385291132
    }
  },
  {
    "code": "971",
    "nom": "Guadeloupe",
    "slug": "guadeloupe",
    "zoom": 10,
    "localisation": {
      "longitude": -61.539863970093414,
      "latitude": 16.197655628844164
    }
  },
  {
    "code": "972",
    "nom": "Martinique",
    "slug": "martinique",
    "zoom": 10,
    "localisation": {
      "longitude": -61.019611234323243,
      "latitude": 14.654897402310562
    }
  },
  {
    "code": "973",
    "nom": "Guyane",
    "slug": "guyane",
    "zoom": 9.1,
    "localisation": {
      "longitude": -52.5,
      "latitude": 4.6
    }
  },
  {
    "code": "974",
    "nom": "La Réunion",
    "slug": "la-reunion",
    "zoom": 10,
    "localisation": {
      "longitude": 55.532518396183427,
      "latitude": -21.133216088566201
    }
  },
  {
    "code": "976",
    "nom": "Mayotte",
    "slug": "mayotte",
    "zoom": 11,
    "localisation": {
      "longitude": 45.147364453253317,
      "latitude": -12.820655090736881
    }
  },
  {
    "code": "978",
    "nom": "Saint Martin",
    "slug": "saint-martin",
    "zoom": 11,
    "localisation": {
      "longitude": -63.0667,
      "latitude": 18.0667
    }
  }
]
